import { arrayOf, string, shape } from 'prop-types';
import React from 'react';

function renderGroup(group) {
  return (
    <div className="Recipe__ingredientsGroup" key={group.id}>
      {group.name && group.name.toLowerCase().trim() !== 'ingredients' && (
        <h4 className="Recipe__ingredientsGroupName">{group.name}</h4>
      )}
      <ul className="Recipe__ingredients">
        {group.items &&
          group.items.map(ingredient => (
            <li className="Recipe__ingredient" key={ingredient.id}>
              {ingredient.quantity && <span>{`${ingredient.quantity} `}</span>}
              {ingredient.unit && <span>{`${ingredient.unit} `}</span>}
              <span
                dangerouslySetInnerHTML={{
                  __html: ingredient.html
                }}
              />
            </li>
          ))}
      </ul>
    </div>
  );
}

function RecipeIngredients(props) {
  const { groups } = props;
  if (!groups || !groups.length) {
    return null;
  }
  return (
    <div className="Recipe__ingredientsGroups">{groups.map(renderGroup)}</div>
  );
}

RecipeIngredients.propTypes = {
  groups: arrayOf(
    shape({
      id: string,
      name: string,
      items: arrayOf(
        shape({
          id: string,
          quantity: string,
          unit: string,
          html: string
        })
      )
    })
  )
};

RecipeIngredients.defaultProps = {
  groups: undefined
};

export default RecipeIngredients;
